import {Typography} from 'components/Typography';
import React, {FC, useRef, useState} from 'react';
import style from './style.module.scss';
import cs from 'classnames';
import Link from 'next/link';
import {PRODUCT_ART_LINK} from 'modules/products/constants';

const SHOW_TOOLTIP_TIME = 300;

export const ListVisualProductCardArt: FC = () => {
    const timeoutIdRef = useRef<NodeJS.Timeout>();
    const [isVisible, setIsVisible] = useState(false);

    const handleMouseEnter = () => {
        clearTimeout(timeoutIdRef.current);
        setIsVisible(true);
    };

    const handleMouseLeave = () => {
        timeoutIdRef.current = setTimeout(() => {
            setIsVisible(false);
        }, SHOW_TOOLTIP_TIME);
    };

    return (
        <div className={cs(style.main, isVisible ? style.isVisible : '')}>
            <Typography className={style.title} element={'div'} variant={'label-12-m'}>
                <span onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                    A.R.T.
                </span>
            </Typography>
            <div className={style.tooltip}>
                <div className={style.tooltipContent}>
                    <Typography variant={'label-12-r'}>
                        Находится в нашей специальной коллекции{' '}
                        <Link className={style.link} href={PRODUCT_ART_LINK}>
                            Simple A.R.T
                        </Link>
                    </Typography>
                </div>
            </div>
        </div>
    );
};
